import { Text, Modal, Button } from '@rsos/base-components';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/base-components/Modal/ModalComponents';
import useDisplayPhoneNumber from '../../../../hooks/useDisplayPhoneNumber';

interface EndChatModalProps {
  callerID: string | null;
  isLoading: boolean;
  isOpened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Modal for ending a conversation
 */
const EndChatModal = ({
  callerID,
  isLoading,
  isOpened,
  onClose,
  onConfirm,
}: EndChatModalProps) => {
  const displayPhoneNumber = useDisplayPhoneNumber(callerID);
  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={350}
      id="modal-end-conversation"
    >
      <ModalHeader onClose={onClose}>
        <Text size="xlarge" fontWeight="semibold" color="secondaryText" mb={15}>
          End Chat with {displayPhoneNumber}?
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text size="normal" color="secondaryText">
          No additional messages will be sent for this incident.
        </Text>
      </ModalBody>
      <ModalFooter flow={12} justify="center">
        <Button btnType="tertiary" grow onClick={onClose}>
          Cancel
        </Button>
        <Button
          btnType="warning_primary"
          onClick={onConfirm}
          grow
          isLoadingProp={isLoading}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EndChatModal;
